
.option {
  display: flex;

  &:not(:last-child) {
    border-bottom: 1px solid silver;
  }

  .icon {
    width: 60px;
    padding: 1em;
  }

  .wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    .title {
      font-weight: 500;
      font-size: 1.1em;
    }

    .sub {
      font-size: 0.9em;
      color: #3c3c3c;
    }
  }
  
}